// extracted by mini-css-extract-plugin
export default {"navList":"Navbar_navList__mGANW","navIsInFooter":"Navbar_navIsInFooter__JAKoo","isInFooter":"Navbar_isInFooter__o-UxY"};